import service from '@/utils/request'

export function getWebViewConfig(config = {}) {
    return service.get('/api/v1/webViewConfig/', config)
}

export function getActivityControls(config = {}) {
    return service.get('/api/v1/activity-controls/', config)
}

export function getNotification(config = {}) {
    return service.get('/api/v1/notification/', config)
}

export function markAppDownloadLog() {
    return service.get('/api/v1/app-download-log/')
}

/** 首页主题：头像/盖章/信件/说明/菜单等 */
export function getHomeTheme() {
    return service.get('/api/v1/home-theme/')
}
